// BV - refresh cart after gwp product is added
(function() {
  document.documentElement.addEventListener('free-gift:added', () => {
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true, detail: { open: true }
    }));
  });
})();

// BV - multi-tier GWP cleanup + auto-add
(function() {
  function readTierData() {
    const el = document.getElementById('free-gift-component-data');
    if (!el) return null;
    try {
      const data = JSON.parse(el.innerHTML);
      const tiers = (data.tiers || []).slice().sort((a, b) => a.threshold_cents - b.threshold_cents);
      return {
        tiers,
        cart_value_cents: data.cart_value_cents || 0,
        gift_wrap_variant_id: data.gift_wrap_variant_id || 0
      };
    } catch (e) {
      console.error('GWP data parse error:', e);
      return null;
    }
  }

  // Mirrors the Liquid snippet's cart_value calc EXACTLY:
  //   sum(final_line_price for requires_shipping items)
  //   - sum(cart_level_discount_applications.total_allocated_amount)
  //   - gift wrap subtraction
  //
  // We use `final_line_price` (explicitly the price AFTER line-level discounts per Shopify's
  // cart.js docs) and only subtract CART-LEVEL discounts. Using `line_price` + `cart.total_discount`
  // double-subtracts line-level discounts because `line_price` in practice returns the after-discount
  // value while `cart.total_discount` includes the SAME line-level discounts.
  function computeCartValue(cart, giftWrapVariantId) {
    let total = 0;
    cart.items.forEach((item) => {
      if (item.requires_shipping) {
        total += item.final_line_price || 0;
      }
    });
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
      cart.cart_level_discount_applications.forEach((d) => {
        total -= d.total_allocated_amount || 0;
      });
    }
    if (giftWrapVariantId) {
      cart.items.forEach((item) => {
        if (item.id === giftWrapVariantId) {
          total -= item.final_line_price || 0;
        }
      });
    }
    return total;
  }

  async function cartChange(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line, quantity })
    });
  }

  async function cartAdd(variantId, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties }] })
    });
  }

  // Find a line item belonging to a specific tier (by property key or legacy _gwp for tier 1)
  function findTierLineItem(cart, tierIndex) {
    const propKey = `_gwp_tier_${tierIndex}`;
    let item = cart.items.find((i) => i.properties && i.properties[propKey] === 'true');
    if (!item && String(tierIndex) === '1') {
      item = cart.items.find((i) => i.properties && i.properties['_gwp'] === 'true');
    }
    return item;
  }

  async function updateGWP() {
    const tierData = readTierData();
    if (!tierData) return;

    const cartRequest = await fetch('/cart.js');
    const cart = await cartRequest.json();

    const cartTotal = computeCartValue(cart, tierData.gift_wrap_variant_id);

    let mutated = false;

    // Iterate tiers ascending; for each, do removal first (if applicable), then auto-add (if applicable).
    for (const tier of tierData.tiers) {
      const lineItem = findTierLineItem(cart, tier.index);

      // 1. Remove if cart dropped below threshold
      if (lineItem && cartTotal < tier.threshold_cents) {
        await cartChange(lineItem.key, 0);
        mutated = true;
        continue;
      }

      // 2. Quantity guard
      if (lineItem && lineItem.quantity > 1) {
        await cartChange(lineItem.key, 1);
        mutated = true;
        continue;
      }

      // 3. Auto-add for single-variant product tier
      if (!lineItem && tier.mode === 'product' && cartTotal >= tier.threshold_cents) {
        const product = tier.products && tier.products[0];
        if (product && product.variants && product.variants.length === 1) {
          const variant = product.variants[0];
          if (variant.available) {
            const propKey = `_gwp_tier_${tier.index}`;
            const props = {};
            props[propKey] = 'true';
            await cartAdd(variant.id, props);
            mutated = true;
          }
        }
      }
    }

    if (mutated) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
    }
  }

  // Debounce: schedule via setTimeout(150ms) so we don't pile up calls on rapid events.
  let scheduled = null;
  function scheduleUpdate() {
    if (scheduled) clearTimeout(scheduled);
    scheduled = setTimeout(() => {
      scheduled = null;
      updateGWP().catch((e) => console.error('GWP updateGWP error:', e));
    }, 150);
  }

  document.addEventListener('cart:quantity-updated', scheduleUpdate);
  document.addEventListener('cart:updated', scheduleUpdate);
  document.addEventListener('ajaxProduct:added', scheduleUpdate);
  document.documentElement.addEventListener('variant:added', scheduleUpdate);
  document.documentElement.addEventListener('free-gift:added', scheduleUpdate);

  scheduleUpdate();
})();
